import { Component } from '@theme/component';
import { isDesktopBreakpoint, debounce } from '@theme/utilities';

export class BannerProductsComponent extends Component {
  static VISIBLE_CLASS = 'banner-products--in-view';
  /** px — reveal the product list slightly before the banner leaves the viewport */
  static VIEWPORT_BUFFER = 100;

  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    super.connectedCallback();
    this.#createObserver();

    // Recreate on resize so rootMargin tracks the current header/dock heights, and
    // so crossing to the desktop breakpoint clears the class (the observer otherwise
    // only fires on scroll).
    window.addEventListener('resize', this.#handleResize, { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#handleResize.cancel?.();
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #handleResize = debounce(() => this.#createObserver(), 200);

  #createObserver() {
    this.#observer?.disconnect();
    this.#observer = new IntersectionObserver(this.#onIntersect, {
      root: null,
      rootMargin: `${this.#getTopOffset()} 0px ${this.#getBottomOffset()} 0px`,
      threshold: 0.25,
    });
    this.#observer.observe(this);
  }

  /** @param {IntersectionObserverEntry[]} entries */
  #onIntersect = (entries) => {
    const [entry] = entries;
    if (!entry) return;
    if (isDesktopBreakpoint()) {
      this.classList.remove(BannerProductsComponent.VISIBLE_CLASS);
      return;
    }
    this.classList.toggle(BannerProductsComponent.VISIBLE_CLASS, entry.isIntersecting);
  };

  #getTopOffset() {
    const header = document.querySelector('.header-mobile-section.header-sticky--always');
    if (!header) return '0px';
    return `-${header.getBoundingClientRect().height}px`;
  }

  #getBottomOffset() {
    let offset = BannerProductsComponent.VIEWPORT_BUFFER;
    const dock = document.querySelector('mobile-dock');
    if (dock) offset += dock.getBoundingClientRect().height;
    return `-${offset}px`;
  }
}

if (!customElements.get('banner-products')) {
  customElements.define('banner-products', BannerProductsComponent);
}
